import type { Organization, Project } from "@overmap-ai/common"
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router"

interface RouterContext {
	isLoggedIn: boolean
	online: boolean
	activeProjectId: Project["uuid"] | null
	activeOrganizationId: Organization["uuid"] | null
}

export const Route = createRootRouteWithContext<RouterContext>()({
	component: Outlet,
})
